import { render, staticRenderFns } from "./positionTable.vue?vue&type=template&id=5e42b9c1&scoped=true&"
import script from "./positionTable.vue?vue&type=script&lang=js&"
export * from "./positionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42b9c1",
  null
  
)

export default component.exports